import { render, staticRenderFns } from "./step6-1.vue?vue&type=template&id=61143050&scoped=true&"
import script from "./step6-1.vue?vue&type=script&lang=js&"
export * from "./step6-1.vue?vue&type=script&lang=js&"
import style0 from "./step6-1.vue?vue&type=style&index=0&id=61143050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61143050",
  null
  
)

export default component.exports